"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var CustomInput = function (_a) {
    var value = _a.value, onBlur = _a.onBlur, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var valueRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (valueRef.current) {
            valueRef.current.value = (value === null || value === void 0 ? void 0 : value.toFixed(3)) || '';
        }
    }, [value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledInput, { disabled: disabled, step: ".01", ref: valueRef, onBlur: function () {
                var _a;
                var valueToChange = Math.abs(Number((_a = valueRef.current) === null || _a === void 0 ? void 0 : _a.value));
                if (!Number.isNaN(valueToChange)) {
                    var decimalValue = valueToChange === 0 ? null : valueToChange.toFixed(3);
                    onBlur(decimalValue);
                }
                if (Number(valueToChange) <= 0 && valueRef.current) {
                    valueRef.current.value = '';
                }
            } })));
};
exports.default = CustomInput;
var StyledInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    text-align: end;\n    border: 1px solid lightgray;\n    width: 100px;\n    height: 30px;\n  }\n"], ["\n  && {\n    text-align: end;\n    border: 1px solid lightgray;\n    width: 100px;\n    height: 30px;\n  }\n"])));
var templateObject_1;
